import { DefaultGrid, GridProvider, useBuildGrid } from '@Components/Grid';

import { usePublisherStore } from '../../store';

import useColumns from './useColumns'
import useDefinitions from './useDefinitions'
import useEvents from './useEvents'

function PublisherGrid() {
  useBuildGrid({
    definitions: useDefinitions(),
    columns: useColumns(),
    events: useEvents(),
  })

  return <DefaultGrid filters={null} />
}

export default function PublisherGridLayout() {
  return <GridProvider store={usePublisherStore()}>
    <PublisherGrid />
  </GridProvider>
}
